import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authenticateNewUser, logoutNewUser } from '../../actions/UserActions';

export default function useAuthenticateUser() {
    const [ authenticationInfo, setAuthenticationInfo ] = useState({
        user: {},
        authenticated: false,
        needsVerified: false,
        individualEmailId: null,
        loggedInFromSso: false,
        magicLink: null
    });
    const [ loggedOut, setLoggedOut ] = useState(false);
    const [ status, setStatus ] = useState({
        hasError: false,
        errorMessage: ''
    });
    const { userAuthenticated, authenticationResponse, userLoggedOut } = useSelector(state => ({
        userAuthenticated: state.user.userAuthenticated,
        authenticationResponse: state.user.authenticationResponse,
        userLoggedOut: state.user.userLoggedOut
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        if (userAuthenticated) {
            setAuthenticationInfo({
                user: authenticationResponse.user,
                authenticated: true,
                needsVerified: authenticationResponse.needsVerified,
                individualEmailId: authenticationResponse.individualEmailId,
                loggedInFromSso: authenticationResponse.loggedInFromSso,
                magicLink: authenticationResponse.magicLink
            });
        } else if (authenticationResponse) {
            setStatus({
                hasError: true,
                errorMessage: 'Error authenticating user'
            });
        }
    }, [userAuthenticated, authenticationResponse]);

    useEffect(() => {
        if (userLoggedOut) {
            setLoggedOut(true);
        }
    }, [userLoggedOut]);

    function loginUser(username, password, memberId, orderType) {
        dispatch(authenticateNewUser(username, password, memberId, orderType));
    }

    function logoutUser() {
        dispatch(logoutNewUser());
    }

    return { authenticationInfo, setAuthenticationInfo, loggedOut, setLoggedOut,
        status, setStatus, userAuthenticated, authenticationResponse, loginUser,
        logoutUser };
}
